import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../assets/logo.png'
import Timer from '../../components/Timer/Timer'
import { UPDATE_CURRENT_LANGUAGE } from '../../constants/actionTypes'
import Button from '../Button/Button'
import ProgressBar from '../ProgressBar/ProgressBar'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'
import stopwatch from '../../assets/stopwatch.svg'
import './Header.css'
import HeaderTitleDropdown from './HeaderTitleDropdown'
import { webengageTrackEvent } from 'utils/webengageService'
import { WEBENGAGE_EVENTS } from 'constants/webengageEvents'
import { GOOGLE_TAG_CONSTANTS } from 'constants/googleTagConstants'

const mapStateToProps = (state) => {
    return {
        completion: state.completion,
        time_completion: state.t,
        testData: state.instructions,
        hideTimer: state.timer,
        queryparam: state.queryparam,
        current_question: state.current_question,
        testStatus: state.testStatus,
        calculated_time_left: state.calculated_time_left,
        current_language: state.current_language,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateCurrentLanguage: (payload) => {
        dispatch({ type: UPDATE_CURRENT_LANGUAGE, payload })
    },
})
export const selectLanguage = (lng) => {
    switch (lng) {
        case 'en':
            return 'English(En)'
        case 'hi':
            return 'Hindi(Hi)'
        case 'gu':
            return 'Gujarati(Gu)'
        default:
            return 'Unsupported language'
    }
}
const Header = (props) => {
    const [isLanguageMountLogged, setIsLanguageMountLogged] = useState(false)
    const [timer, setTimer] = useState()
    const [showHeader, setShowHeader] = useState(true)
    const [dropdown, setDropdown] = useState(false)
    const location = useLocation()
    let timerAddress = timer
    const wrapperRef = useRef(null)
    const { t, i18n } = useTranslation()

    function logEvents(eventName, description, extraData) {
        props.handleGTagLogs(eventName, description, extraData)
    }

    if (props.time_completion === -1) {
        clearInterval(timerAddress)
    }
    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setDropdown(false)
        }
    }

    useEffect(() => {
        if (location.pathname === '/success') {
            setShowHeader(false)
        } else {
            setShowHeader(true)
        }
    }, [location.pathname])

    useEffect(() => {
        if (!isLanguageMountLogged && i18n.language && !props.isPreview) {
            logEvents(
                GOOGLE_TAG_CONSTANTS.TAP_LANGUAGE_TEST_START_WEB,
                'Event when user starts/resumes the test',
                {
                    Language: selectLanguage(i18n.language),
                    external_id:
                        props.current_question?.question?.questionExternalId,
                    question_id: props.current_question?.question?.questionid,
                    section_name: props.current_question?.subject,
                    user_test_id: props.testStatus?.testStatus?.data?.userTestId,
                },
            )
            setIsLanguageMountLogged(true)
        }
    }, [i18n.language])

    const handleLangChange = (evt, language) => {
        const lang = evt.target.value
        webengageTrackEvent(WEBENGAGE_EVENTS.TP_LANGUAGE_SELECTION, {
            'Test language': evt.target.value,
        })

        logEvents(
            GOOGLE_TAG_CONSTANTS.TAP_LANGUAGE_INSTRUCTION_WEB,
            'User changes the language on the instruction screen',
            {
                Language: selectLanguage(lang),
                external_id: props.current_question?.question?.questionExternalId,
                question_id: props.current_question?.question?.questionid,
                section_name: props.current_question?.subject,
                user_test_id: props.testStatus?.testStatus?.data?.userTestId,
            },
        )

        props.updateCurrentLanguage(lang)
        i18n.changeLanguage(lang)
        setDropdown(false)
    }

    const handleLangDropdownClick = () => {
        setDropdown(!dropdown)
    }

    if (!showHeader) {
        return null
    }

    return (
        <header>
            {props?.hideTimer?.hideTimer !== false && (
                <div className="header" style={props.style}>
                    <HeaderTitleDropdown
                        selectLanguage={selectLanguage}
                        handleLangChange={handleLangChange}
                        showToggle={false}
                    ></HeaderTitleDropdown>
                </div>
            )}
            {!props?.hideTimer?.hideTimer ? (
                <div className="header" style={props.style}>
                    <HeaderTitleDropdown
                        selectLanguage={selectLanguage}
                        handleLangChange={handleLangChange}
                        showToggle={true}
                    ></HeaderTitleDropdown>

                    <div className="progressbar">
                        {!props.isPreview ? (
                            <div className="timer-progressbar">
                                <div className="timer-stopwatch">
                                    <img
                                        className="stopwatch-img"
                                        alt="stopwatch"
                                        src={stopwatch}
                                    ></img>
                                    <Timer
                                        timerAddress={timer}
                                        class={'timer'}
                                        setTimer={setTimer}
                                        handleGTagLogs={props.handleGTagLogs}
                                    />
                                </div>
                                <ProgressBar
                                    done={props.completion.completion}
                                    opacity={'1'}
                                />
                            </div>
                        ) : null}
                        <div className="completion">
                            {!props.isPreview ? (
                                <span className="completion-value">
                                    {props.completion.completion}%
                                </span>
                            ) : null}
                            <Link to="/submit">
                                <Button
                                    onClick={async () =>
                                        !props.isPreview &&
                                        logEvents(
                                            GOOGLE_TAG_CONSTANTS.TAP_END_TEST_WEB,
                                            'User taps on the end test button ',
                                            {
                                                success: true,
                                                question_id:
                                                    props.current_question.question
                                                        .questionid,
                                                section_name:
                                                    props.current_question.subject[
                                                        props.current_language
                                                    ],
                                                user_test_id:
                                                    props.testStatus?.testStatus
                                                        ?.data?.userTestId,
                                                disconnection_time:
                                                    props.queryparam
                                                        .disconnect_time * 60,
                                                external_id:
                                                    props.current_question.question
                                                        .questionExternalId,
                                            },
                                        )
                                    }
                                    name={'End Test'}
                                    classes={
                                        isInPhoneOrTablet()
                                            ? 'is_phone'
                                            : 'is_phone_not'
                                    }
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="timer-progressbar-blank"></div>
            )}
        </header>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
